module.exports = __webpack_public_path__ + "img/Spain1.8a84cb4c.png";